import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const AISuggestionIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M10.7658 3.68269C10.6757 3.4391 10.3313 3.4391 10.2412 3.68269L8.47171 8.46718L3.68016 10.2411C3.43995 10.33 3.43995 10.67 3.68016 10.7589L8.47171 12.5328L10.2412 17.3173C10.3313 17.5609 10.6757 17.5609 10.7658 17.3173L12.5353 12.5328L17.3174 10.7624C17.5609 10.6723 17.5609 10.3277 17.3174 10.2376L12.5353 8.46718L10.7658 3.68269ZM17.1329 13.5913C17.0878 13.4696 16.9157 13.4696 16.8706 13.5913L15.9859 15.9836L13.5901 16.8706C13.47 16.915 13.47 17.085 13.5901 17.1294L15.9859 18.0164L16.8706 20.4087C16.9157 20.5304 17.0878 20.5304 17.1329 20.4087L18.0177 18.0164L20.4087 17.1312C20.5304 17.0861 20.5304 16.9139 20.4087 16.8688L18.0177 15.9836L17.1329 13.5913Z"
      />
    </SvgIcon>
  );
});
